<template lang="pug">
.default-container
    .default-sidebar
        slot(
            name="sidebar"
        )
    .default-content
        slot
</template>

<script>
export default {
  name: 'DefultLayout',
};
</script>

<style lang="scss" scoped>
.default-container {
    padding: 30px;
    display: flex;
}

.default-content {
    margin-left: 30px;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.default-content {
    min-height: calc(100vh - 60px);
}
</style>
